import {useEffect, useState} from "react";

const PreventBack = () => {

    useEffect(() => {
        const handleBack = () => {
            //window.history.forward();
            //window.history.pushState(null, '', '/main');  // 페이지 강제로 이동
            //window.history.pushState(null, '', window.location.href);
            window.history.pushState(null, "", window.location.href);
        };

        window.history.pushState(null, "", window.location.href);

        window.addEventListener("popstate", handleBack);

        return () => {
            window.removeEventListener("popstate", handleBack);
        };
    }, []);

    return null;
};

export default PreventBack;